(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-media-content"] && !Shopify.designMode) return;
  try {
    
class MwcAccordionSection extends HTMLElement {
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll(':scope > .mwc-tab'));
    if (!this._items.length) return;

    this.addEventListener('click', this._handleClick.bind(this));
    this._openItem(0);
  }

  _handleClick(e) {
    const summary = e.target.closest('.js-mwc-tab-summary');
    if (!summary) return;
    e.preventDefault();
    const item = summary.closest('.mwc-tab');
    const index = this._items.indexOf(item);
    if (index === -1) return;
    const isOpen = item.classList.contains('is-active');
    this._openItem(isOpen ? -1 : index);
  }

  _openItem(index) {
    this._items.forEach((item, i) => {
      const summary = item.querySelector('.js-mwc-tab-summary');
      const isOpen = i === index;

      item.classList.toggle('is-active', isOpen);
      if (summary) summary.setAttribute('aria-expanded', String(isOpen));

      if (isOpen) {
        item.setAttribute('open', '');
      } else {
        item.removeAttribute('open');
      }
    });
  }
}

if (!customElements.get('mwc-accordion-section')) {
  customElements.define('mwc-accordion-section', MwcAccordionSection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-stats"] && !Shopify.designMode) return;
  try {
    
class FqsTabs extends HTMLElement {
  connectedCallback() {
    this._tabs = Array.from(this.querySelectorAll('[data-fqs-tab]'));
    this._panels = Array.from(this.querySelectorAll('[data-fqs-panel]'));
    if (!this._tabs.length) return;

    this._interval = parseInt(this.dataset.interval, 10) || 5000;
    this._autoplay = this.dataset.autoplay !== 'false';
    this._currentIndex = 0;
    this._timer = null;
    this._hovered = false;
    this._visible = true;
    this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this._rightColumn = this.querySelector('.fqs__right');
    this._isMobileLayout = null;
    this._mobileQuery = window.matchMedia('(max-width: 749px)');
    this._mobileQuery.addEventListener('change', () => this._layoutForViewport());
    this._layoutForViewport();

    this.addEventListener('click', this._onClick.bind(this));
    this.addEventListener('mouseenter', () => { this._hovered = true; this._stop(); });
    this.addEventListener('mouseleave', () => { this._hovered = false; this._resume(); });

    this._observer = new IntersectionObserver(
      (entries) => {
        this._visible = entries[0].isIntersecting;
        this._visible ? this._resume() : this._stop();
      },
      { threshold: 0.1 }
    );
    this._observer.observe(this);

    this._activate(0);
  }

  disconnectedCallback() {
    this._stop();
    if (this._observer) this._observer.disconnect();
  }

  _onClick(e) {
    const tab = e.target.closest('[data-fqs-tab]');
    if (!tab) return;
    const index = this._tabs.indexOf(tab);
    if (index < 0) return;

    if (index === this._currentIndex) {
      if (this._isMobileLayout) {
        this._stop();
        this._collapse();
      }
      return;
    }

    this._stop();
    this._activate(index);
    this._resume();
  }

  _activate(index) {
    const targetId = this._tabs[index] && this._tabs[index].dataset.fqsTab;

    this._tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('aria-expanded', String(active));

      const bar = tab.querySelector('.fqs__tab-bar');
      if (bar) {
        bar.style.animation = 'none';
        bar.offsetHeight;
        if (active && !this._reducedMotion && this._autoplay) {
          bar.style.animation = '';
        }
      }
    });

    this._panels.forEach((panel) => {
      const active = panel.dataset.fqsPanel === targetId;
      panel.classList.toggle('is-active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    this._currentIndex = index;
  }

  _collapse() {
    this._tabs.forEach((tab) => {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('aria-expanded', 'false');

      const bar = tab.querySelector('.fqs__tab-bar');
      if (bar) bar.style.animation = 'none';
    });

    this._panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('hidden', '');
    });

    this._currentIndex = -1;
  }

  _advance() {
    this._activate((this._currentIndex + 1) % this._tabs.length);
  }

  _layoutForViewport() {
    const isMobile = this._mobileQuery.matches;
    if (isMobile === this._isMobileLayout) return;
    this._isMobileLayout = isMobile;

    this._tabs.forEach((tab, i) => {
      const panel = this._panels[i];
      if (!panel) return;
      if (isMobile) {
        tab.insertAdjacentElement('afterend', panel);
      } else if (this._rightColumn) {
        this._rightColumn.appendChild(panel);
      }
    });
  }

  _start() {
    if (this._timer) return;
    this._timer = setInterval(() => this._advance(), this._interval);
  }

  _stop() {
    clearInterval(this._timer);
    this._timer = null;
  }

  _resume() {
    if (!this._autoplay || this._reducedMotion || this._hovered || !this._visible) return;
    this._start();
  }
}

if (!customElements.get('fqs-tabs')) {
  customElements.define('fqs-tabs', FqsTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-two-column"] && !Shopify.designMode) return;
  try {
    
class TimedAccordionSection extends HTMLElement {
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('.ftc-item'));
    if (!this._items.length) return;

    this._interval = parseInt(this.dataset.interval, 10) || 5000;
    this._autoplay = this.dataset.autoplay !== 'false';
    this._showProgress = this.dataset.showProgress !== 'false';
    this._currentIndex = 0;
    this._timer = null;
    this._hovered = false;
    this._focused = false;
    this._visible = true;
    this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.addEventListener('click', this._handleClick.bind(this));
    this.addEventListener('mouseenter', () => { this._hovered = true; this._stop(); this._updatePauseVisual(); });
    this.addEventListener('mouseleave', () => { this._hovered = false; this._resume(); this._updatePauseVisual(); });
    this.addEventListener('focusin', () => { this._focused = true; this._stop(); this._updatePauseVisual(); });
    this.addEventListener('focusout', () => { this._focused = false; this._resume(); this._updatePauseVisual(); });

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this._visible = entry.isIntersecting;
          if (this._visible) {
            this._resume();
          } else {
            this._stop();
          }
        });
        this._updatePauseVisual();
      },
      { threshold: 0.1 }
    );
    this._observer.observe(this);

    this._openItem(0);
  }

  disconnectedCallback() {
    this._stop();
    if (this._observer) this._observer.disconnect();
  }

  _handleClick(e) {
    const summary = e.target.closest('.js-ftc-summary');
    if (!summary) return;
    e.preventDefault();
    const item = summary.closest('.ftc-item');
    const index = this._items.indexOf(item);
    if (index === -1) return;
    this._stop();
    this._openItem(index === this._currentIndex ? -1 : index);
    this._resume();
  }

  _openItem(index) {
    this._items.forEach((item, i) => {
      const summary = item.querySelector('.js-ftc-summary');
      const bar = item.querySelector('.ftc-item__bar');
      const isOpen = i === index;

      item.classList.toggle('is-active', isOpen);
      if (summary) summary.setAttribute('aria-expanded', String(isOpen));

      if (isOpen) {
        item.setAttribute('open', '');
      } else {
        item.removeAttribute('open');
      }

      if (bar) {
        bar.style.animation = 'none';
        bar.offsetHeight;
        if (isOpen && this._showProgress && !this._reducedMotion) {
          bar.style.animation = '';
        }
      }
    });

    this._currentIndex = index;
  }

  _advance() {
    const next = (this._currentIndex + 1 + this._items.length) % this._items.length;
    this._openItem(next);
  }

  _start() {
    if (this._timer) return;
    this._timer = setInterval(() => this._advance(), this._interval);
  }

  _stop() {
    clearInterval(this._timer);
    this._timer = null;
  }

  _resume() {
    if (!this._autoplay || this._reducedMotion || this._hovered || this._focused || !this._visible) return;
    this._start();
  }

  _updatePauseVisual() {
    const shouldPause = this._hovered || this._focused || !this._visible;
    this.classList.toggle('is-paused', shouldPause);
  }
}

if (!customElements.get('timed-accordion-section')) {
  customElements.define('timed-accordion-section', TimedAccordionSection);
}

  } catch(e) { console.error(e); }
})();
})();
